<template>
   <header>
      <nav class="navbar fixed-top">
         <router-link to="" class="navbar-brand">{{activeTitle}}</router-link>
         <a v-b-modal.filterModal class="filter-icon" v-if="defaultFilter.searchFn" >
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
               viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
               <g>
                  <g>
                     <path d="M490.667,405.333h-56.811C424.619,374.592,396.373,352,362.667,352s-61.931,22.592-71.189,53.333H21.333
                        C9.557,405.333,0,414.891,0,426.667S9.557,448,21.333,448h270.144c9.237,30.741,37.483,53.333,71.189,53.333
                        s61.931-22.592,71.189-53.333h56.811c11.797,0,21.333-9.557,21.333-21.333S502.464,405.333,490.667,405.333z M362.667,458.667
                        c-17.643,0-32-14.357-32-32s14.357-32,32-32s32,14.357,32,32S380.309,458.667,362.667,458.667z"/>
                  </g>
               </g>
               <g>
                  <g>
                     <path d="M490.667,64h-56.811c-9.259-30.741-37.483-53.333-71.189-53.333S300.736,33.259,291.477,64H21.333
                        C9.557,64,0,73.557,0,85.333s9.557,21.333,21.333,21.333h270.144C300.736,137.408,328.96,160,362.667,160
                        s61.931-22.592,71.189-53.333h56.811c11.797,0,21.333-9.557,21.333-21.333S502.464,64,490.667,64z M362.667,117.333
                        c-17.643,0-32-14.357-32-32c0-17.643,14.357-32,32-32s32,14.357,32,32C394.667,102.976,380.309,117.333,362.667,117.333z"/>
                  </g>
               </g>
               <g>
                  <g>
                     <path d="M490.667,234.667H220.523c-9.259-30.741-37.483-53.333-71.189-53.333s-61.931,22.592-71.189,53.333H21.333
                        C9.557,234.667,0,244.224,0,256c0,11.776,9.557,21.333,21.333,21.333h56.811c9.259,30.741,37.483,53.333,71.189,53.333
                        s61.931-22.592,71.189-53.333h270.144c11.797,0,21.333-9.557,21.333-21.333C512,244.224,502.464,234.667,490.667,234.667z
                        M149.333,288c-17.643,0-32-14.357-32-32s14.357-32,32-32c17.643,0,32,14.357,32,32S166.976,288,149.333,288z"/>
                  </g>
               </g>
            </svg>
            <span class="selectedFilter" v-if="isFilterActive"></span>
         </a>
         <div class="modalHolder">
            <b-modal  id="filterModal"   hide-header hide-footer >
                <div class="search-holder">
                  <h3>Filter <button type="button" aria-label="Close" class="close" @click="hideModal">×</button></h3>
                  <div class="form-group" v-if="activeTitle !== 'Backlog Report'">
                     <b-form-group label="">
                        <b-form-tags v-model="selectedProjectNames" no-outer-focus class="form-control custom-select">
                            <template v-slot="{ tags, disabled, addTag, removeTag }">
                              <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
                                  <li v-for="tag in tags" :key="tag" class="list-inline-item">
                                    <b-form-tag
                                        @remove="removeProject(tag)"
                                        :title="tag"
                                        :disabled="disabled"
                                        variant="info"
                                        >{{ tag }}</b-form-tag>
                                  </li>
                              </ul>
                              <b-dropdown size="sm" variant="outline-secondary" block menu-class="w-100">
                                  <template v-slot:button-content>
                                    Search Projects
                                  </template>
                                  <b-dropdown-form @submit.stop.prevent="() => {}">
                                    <b-form-input
                                      v-model="search"
                                      id="tag-search-input"
                                      type="search"
                                      size="sm"
                                      autocomplete="on"
                                      placeholder="Enter project name to search"
                                      @input="populateSuggestions"
                                      ></b-form-input>
                                  </b-dropdown-form>
                                  <b-dropdown-divider></b-dropdown-divider>
                                  <b-dropdown-item-button
                                    v-for="option in availableOptions"
                                    :key="`options${option.id}`"
                                    @click="selectProject(option)"
                                    >
                                    {{ option.name }}
                                  </b-dropdown-item-button>
                                  <b-dropdown-text v-if="availableOptions.length === 0">
                                    {{noItem}}
                                  </b-dropdown-text>
                              </b-dropdown>
                            </template>
                        </b-form-tags>
                      </b-form-group>
                  </div>
                  <!-- sub projects select start -->
                  <b-form-group v-if="activeTitle === 'Lead Ageing Report' || activeTitle === 'Marketing Campaign Report'">
                    <multiselect 
                      class="mt-2" v-model="selectedSubProjects" @search-change="populateSubProject"
                      :searchable="true" @input="selectSubProjects()" :placeholder="`Search Sub projects`" label="name"
                      track-by="id" :options="subProjectOptions" :multiple="true" :taggable="true">
                    </multiselect>
                  </b-form-group>
                  <!-- sub projects select end -->

                  <!-- city select start -->
                  <b-form-group v-if="activeTitle === 'Lead Ageing Report'">
                    <multiselect 
                      class="mt-2" v-model="selectedCities" @input="selectCities()"
                      :searchable="true" :placeholder="`Select Cities`" label="name"
                      track-by="id" :options="city_list ? city_list : []" :multiple="true" :taggable="true">
                    </multiselect>
                  </b-form-group>
                  <div v-if="activeTitle === 'Marketing Campaign Report'">
                   <!-- sub Campaign Id start -->
                  <b-form-group>
                    <multiselect 
                      class="mt-2" v-model="selectedCampaigns" @search-change="searchCampaignIds"
                      :searchable="true" @input="selectCampaigns()" :placeholder="`Search Campaign Id`" label="campaign_id"
                      track-by="id" :options="campaignsIds" :multiple="true" :taggable="true">
                    </multiselect>
                  </b-form-group>
                  <!-- sub Campaign Id end -->
                    <!-- Ad group start -->
                  <b-form-group>
                    <multiselect 
                      class="mt-2" v-model="selectedAdGroups" @search-change="searchAdgroupIds"
                      :searchable="true" @input="selectAdGroups()" :placeholder="`Search Ad Group Id`" label="ad_group_id"
                      track-by="id" :options="adGroupsIds" :multiple="true" :taggable="true">
                    </multiselect>
                  </b-form-group>
                  <!-- Ad group Id end -->
                   <b-form-group>
                    <multiselect 
                      class="mt-2" v-model="physical_pincode" @search-change="searchPincode"
                      :searchable="true" @input="selectPincode()" :placeholder="`Search Pincode`" label="pincode"
                      track-by="pincode" :options="physicalPincode" :multiple="true" :taggable="true">
                    </multiselect>
                  </b-form-group>
                    <b-form-group>

                  <!-- ad_strategies -->
                    <multiselect 
                      class="mt-2" v-model="ad_strategies" :searchable="true" @input="selectAdStrategies()" placeholder="Select Ad Strategies" :options="mtrReportFilters?.ad_strategies" :multiple="true" :taggable="true">
                    </multiselect>
                  </b-form-group>
                  <!-- ads_names -->
                  <b-form-group>
                    <multiselect 
                      class="mt-2" v-model="ads_names" :searchable="true" @input="selectAdsNames()" placeholder="Select Ads Names" :options="mtrReportFilters?.ads_names" :multiple="true" :taggable="true">
                    </multiselect>
                  </b-form-group>
                  <!-- devices -->
                    <b-form-group>
                    <multiselect 
                      class="mt-2" v-model="devices" :searchable="true" @input="selectDevices()" placeholder="Select Devices"
                      :options="mtrReportFilters?.devices" :multiple="true" :taggable="true">
                    </multiselect>
                  </b-form-group>
                  <!-- keyword_types -->
                  <b-form-group>
                    <multiselect 
                      class="mt-2" v-model="keyword_types" :searchable="true" @input="selectKeywordTypes()" placeholder="Select Keyword Types"
                      :options="mtrReportFilters?.keyword_types" :multiple="true" :taggable="true">
                    </multiselect>
                  </b-form-group>
                  <!-- utm_campaigns -->
                  <b-form-group>
                    <multiselect 
                      class="mt-2" v-model="utm_campaigns" :searchable="true" @input="selectUtmCampaigns()" placeholder="Select UTM Campaigns"
                      :options="mtrReportFilters?.utm_campaigns" :multiple="true" :taggable="true">
                    </multiselect>
                  </b-form-group>
                  </div>

                  <!-- city select end -->
                  <b-form-group label="Take Rate" v-if="activeTitle === 'ROI User Wise Report' || activeTitle === 'ROI Project Wise Report' || activeTitle === 'ROI Source Wise Report'">
                      <b-row class="align-items-center">
                        <b-col>
                          <b-form-input
                            v-model.number="take_rate_from"
                            type="number"
                            placeholder="From"
                            class="w-100"
                            @input="$store.dispatch('setTakeRateFrom', take_rate_from)"
                          ></b-form-input>
                        </b-col>
                        <b-col>
                          <b-form-input
                            v-model.number="take_rate_upto"
                            type="number"
                            placeholder="Upto"
                            class="w-100"
                            @input="$store.dispatch('setTakeRateUpto', take_rate_upto)"
                          ></b-form-input>
                        </b-col>
                      </b-row>
                    </b-form-group>
                  <!-- Ticket Size Range -->
                  <b-form-group label="Ticket Size" v-if="activeTitle === 'ROI User Wise Report' || activeTitle === 'ROI Project Wise Report' || activeTitle === 'ROI Source Wise Report'">
                    <b-row class="align-items-center">
                      <b-col>
                        <b-form-input
                          v-model.number="average_ticket_size_from"
                          type="number"
                          placeholder="From"
                          class="w-100"
                          @input="$store.dispatch('setTicketSizeFrom', average_ticket_size_from)"
                        ></b-form-input>
                      </b-col>
                      <b-col>
                        <b-form-input
                          v-model.number="average_ticket_size_upto"
                          type="number"
                          placeholder="Upto"
                          class="w-100"
                          @input="$store.dispatch('setTicketSizeUpto', average_ticket_size_upto)"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-form-group>

                  <!-- Revenue Range -->
                  <b-form-group label="Revenue" v-if="activeTitle === 'ROI User Wise Report' || activeTitle === 'ROI Project Wise Report' || activeTitle === 'ROI Source Wise Report'">
                    <b-row class="align-items-center">
                      <b-col>
                        <b-form-input
                          v-model.number="revenue_from"
                          type="number"
                          placeholder="From"
                          class="w-100"
                          @input="$store.dispatch('setRevenueFrom', revenue_from)"
                        ></b-form-input>
                      </b-col>
                      <b-col>
                        <b-form-input
                          v-model.number="revenue_upto"
                          type="number"
                          placeholder="Upto"
                          class="w-100"
                          @input="$store.dispatch('setRevenueUpto', revenue_upto)"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-form-group>
                  <b-form-group  v-if="activeTitle === 'ROI User Wise Report' || activeTitle === 'Lead Ageing Report'">
                    <select
                      v-model="user_active"
                      @change="selectActiveUser"
                      class="form-control"
                    >
                      <option :value="null">Select Active User</option>
                      <option v-for="(option,index) in user_actives" :key="index" :value="option.value">
                        {{ option.key }}
                      </option>
                    </select>
                  </b-form-group>

                  <b-form-group  v-if="activeTitle === 'Backlog Report'">
                    <b-form-input style="padding: 24px 10px" v-model="enquiry" trim  @input="onEnquiryInput" placeholder="Enquiry"></b-form-input>
                  </b-form-group>
                  <b-form-group  v-if="activeTitle === 'Qualification Report' || activeTitle === 'Backlog Report'">
                    <select
                      v-model="executive_type"
                      @change="selectExecutive"
                      class="form-control"
                    >
                      <option :value="null">Select Executive Type</option>
                      <option v-for="option in executive_types" :key="option.id" :value="option.id">
                        {{ option.name }}
                      </option>
                    </select>
                  </b-form-group>

                  <b-form-group  v-if="activeTitle === 'Call Activity Report'">
                    <select
                      @change="selectRunoUser"
                      v-model="runo_user"
                      class="form-control"
                    >
                      <option :value="null">Select Is Runo user</option>
                      <option v-for="(option,index) in runo_call_user" :key="index" :value="option.value">
                        {{ option.key }}
                      </option>
                    </select>
                  </b-form-group>
                  <b-form-group v-if="activeTitle === 'Call Activity Report' || activeTitle === 'Backlog Report' || activeTitle === 'Lead Ageing Report'">
                    <multiselect 
                      class="mt-2" v-model="selectedExeUsers" @input="selectExeUsers()"
                      :searchable="true" :placeholder="`Select Executive Users`" label="name"
                      track-by="id" :options="exe_users ? exe_users : []" :multiple="true" :taggable="true">
                    </multiselect>
                  </b-form-group>

                  <b-form-group v-if="activeTitle === 'Call Activity Report'">
                    <multiselect 
                      class="mt-2" v-model="selectedThirdParties" @input="selectThirdParties()"
                      :searchable="true" :placeholder="`Select Third Parties`" label="name"
                      track-by="id" :options="third_parties ? third_parties : []" :multiple="true" :taggable="true">
                    </multiselect>
                  </b-form-group>
                  <b-form-group v-if="activeTitle === 'Call Activity Report' || activeTitle === 'Backlog Report'  || activeTitle === 'ROI User Wise Report' || activeTitle === 'ROI Project Wise Report' || activeTitle === 'ROI Source Wise Report' || activeTitle === 'Marketing Activation Report' || activeTitle === 'Lead Ageing Report'">
                    <multiselect 
                      class="mt-2" v-model="selectedMultiManager" @input="selectMultiManager()"
                      :searchable="true" :placeholder="`Select Manager List`" label="name"
                      track-by="id" :options="managerList ? managerList : []" :multiple="true" :taggable="true">
                    </multiselect>
                  </b-form-group>

                  <b-form-group v-if="activeTitle === 'Qualification Report' || activeTitle === 'Call Activity Report'  || activeTitle === 'Backlog Report'  || activeTitle === 'ROI User Wise Report' || activeTitle === 'ROI Project Wise Report' || activeTitle === 'ROI Source Wise Report'">
                    <multiselect 
                      class="mt-2" v-model="selectedStatus" @input="selectStatus()"
                      :searchable="true" :placeholder="`Select Status`" label="name"
                      track-by="id" :options="statuses ? statuses : []" :multiple="true" :taggable="true">
                    </multiselect>
                  </b-form-group>

                  <b-form-group v-if="activeTitle === 'Qualification Report'  || activeTitle === 'Backlog Report'  || activeTitle === 'ROI User Wise Report' || activeTitle === 'ROI Project Wise Report' || activeTitle === 'ROI Source Wise Report'">
                    <multiselect 
                      class="mt-2" v-model="selectedSubStatus" @input="selectSubStatus()"
                      :searchable="true" :placeholder="`Select Sub Status`" label="name"
                      track-by="id" :options="sub_statuses ? sub_statuses : []" :multiple="true" :taggable="true">
                    </multiselect>
                  </b-form-group>
                  <b-form-group  v-if="activeTitle === 'Backlog Report'">
                  <b-form-checkbox
                      id="checkbox-1"
                      v-model="todays_call"
                      name="checkbox-1"
                      :value="true"
                      :unchecked-value="false"
                       @change="onTodaysCallCheck"
                    >
                      Todays call
                    </b-form-checkbox>
                  </b-form-group>

                  <b-form-group  v-if="activeTitle === 'Marketing Activation Report'">
                  <b-form-checkbox
                      id="checkbox-1"
                      v-model="is_star_project"
                      name="checkbox-1"
                      :value="true"
                      :unchecked-value="false"
                      @change="onStarProjectCheck"
                    >
                      Is Star Project
                    </b-form-checkbox>
                  </b-form-group>

                  <p v-if="activeTitle != 'Call Activity Report'">Sources:</p>
                  <div class="form-group row" v-if="activeTitle != 'Call Activity Report'">
                    <button 
                      v-for="(source, key) in sourceList" 
                      :key="`source${key}`" 
                      type="button" 
                      class="btn btn-filter btn-sm btn-outline" 
                      :class="{active : sSources.indexOf(source.id) > -1}"
                      @click="toggleSource(source.id)"
                      >{{source.name}}
                    </button>
                  </div>
                  <hr/>
                  <p v-if="activeTitle !== 'Call Activity Report' && activeTitle !== 'Backlog Report' && activeTitle !== 'ROI User Wise Report' && activeTitle !== 'ROI Source Wise Report' && activeTitle !== 'ROI Project Wise Report' && activeTitle !== 'Marketing Activation Report' && activeTitle !== 'Lead Ageing Report' && activeTitle !== 'Marketing Campaign Report'">Managers:</p>

                  <div class="form-group row" v-if="activeTitle !== 'Call Activity Report' && activeTitle !== 'Backlog Report' && activeTitle !== 'ROI User Wise Report' && activeTitle !== 'ROI Source Wise Report' && activeTitle !== 'ROI Project Wise Report' && activeTitle !== 'Marketing Activation Report' && activeTitle !== 'Lead Ageing Report' && activeTitle !== 'Marketing Campaign Report'">
                    <button 
                      v-for="(manager, key) in managerList" 
                      :key="`manager${key}`" 
                      type="button" 
                      class="btn btn-filter btn-sm btn-outline" 
                      :class="{active : sManager === manager.id}"
                      @click="toggleManager(manager.id)"
                      >{{manager.name}}
                    </button>
                  </div>
                </div>
                  <div class="fixed-btn">
                    <span @click="clearFilters" class="clearfilter">Clear Filters</span>
                <button v-if="defaultFilter.searchFn" type="submit" class="btn btn-login btn-block" @click="applyFilter">Apply</button>
                </div>
            </b-modal>
         </div>
      </nav>
   </header>
</template>
<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect,
  },
  data(){
    return {
      managerList: [],
      sourceList: [],
      projectOptions: [],
      executive_types: [],
      sub_statuses: [],
      selectedSubStatus: [],
      selectedStatus: [],
      exe_users: [],
      selectedExeUsers: [],
      selectedCities: [],
      selectedThirdParties: [],
      selectedMultiManager: [],
      runo_call_user: [],
      third_parties: [],
      runo_user: null,
      executive_type: null,
      enquiry: '',
      todays_call: false,
      take_rate_from: null,
      take_rate_upto: null,
      average_ticket_size_from:null,
      average_ticket_size_upto: null,
      revenue_from: null,
      revenue_upto: null,
      user_actives: [],
      user_active: null,
      statuses: [],
      search: '',
      executive_id: '',
      noItem: 'Start typing....',
      city_list:[],
      selectedSubProjects: [],
      subProjectOptions:[],
      adGroupsIds:[],
      campaignsIds:[],
      selectedAdGroups: [],
      selectedCampaigns: [],
      physical_pincode: null,
      physicalPincode:[],
      ad_strategies: [],
      ads_names: [],
      devices: [],
      keyword_types: [],
      utm_campaigns: []
    }
  },
  async beforeCreate(){
    await this.$axios.get("/settings")
      .then(res => {
        let {sources, managers, executive_types, sub_statuses, statuses, exe_users, third_parties, runo_call_user, user_active,cities} = res.data
        this.managerList = managers;
        this.sourceList = sources;
        this.executive_types = executive_types;
        this.sub_statuses = sub_statuses;
        this.statuses = statuses;
        this.exe_users = exe_users;
        this.third_parties = third_parties;
        this.runo_call_user = runo_call_user
        this.user_actives = user_active
        this.city_list = cities;
        })
      .catch(err => console.log(err));
      if (this.$route.query.manager_ids) {
        const ids = this.$route.query.manager_ids.split(',').map(id => parseInt(id));
        this.selectedMultiManager = this.managerList.filter(manager => ids.includes(manager.id));
      }
  },
  methods: {
    toggleManager(managerId){
      if(this.sManager === managerId){
        this.$store.dispatch('setSelectedManager', null)
      }else{
        this.$store.dispatch('setSelectedManager', managerId)
      }
    },
    populateSuggestions(event){
      if(event.length === 3){
        this.noItem = "Loading Suggestions......"
        let url = `/projects?input_str=${event.trim()}`
        this.$axios.get(url)
          .then(res => {
            this.noItem = "No Results!"
            if(res.data.projects.length > 0){
              this.projectOptions = res.data.projects
            }
          })
          .catch(err => {
            this.noItem = "Something Went Wrong!!"
          })
      }
    },
    populateSubProject(event) {
      if (event.length === 3) {
        let url = `/sub_projects_search?input_str=${event.trim()}`
        this.$axios.get(url)
          .then(res => {
            if (res.data?.data?.length > 0) {
              this.subProjectOptions = res.data.data;
            }
          }).catch(err => {
            console.log(err);
          })
      }
    },
    searchCampaignIds(event) {
      if (event.length === 3) {
        let url = `/search_ad_campaign?input_str=${event.trim()}`
        this.$axios.get(url)
          .then(res => {
            if (res.data?.ad_campaigns?.length > 0) {
              this.campaignsIds = res.data.ad_campaigns;
            }
          }).catch(err => {
            console.log(err);
          })
      }
    },
    searchAdgroupIds(event) {
      if (event.length === 3) {
        let url = `/search_ad_group?input_str=${event.trim()}`
        this.$axios.get(url)
          .then(res => {
            if (res.data?.ad_groups?.length > 0) {
              this.adGroupsIds = res.data.ad_groups;
            }
          }).catch(err => {
            console.log(err);
          })
      }
    },
    searchPincode(event){
      if (event.length === 3) {
        let url = `/search_pincode?input_str=${event.trim()}`
        this.$axios.get(url)
          .then(res => {
            if (res.data?.length > 0) {
              this.physicalPincode = res.data;
            }
          }).catch(err => {
            console.log(err);
          })
      }
    },
    clearFilters(){
      this.$store.dispatch('clearFilters');
      this.selectedSubStatus = []
      this.selectedStatus = []
      this.selectedExeUsers = []
      this.selectedCities = []
      this.selectedSubProjects = []
      this.selectedThirdParties = []
      this.selectedMultiManager = []
      this.runo_user = null
      this.todays_call = null
      this.enquiry = null
      this.executive_type = null
      this.take_rate_from = null,
      this.take_rate_upto = null,
      this.revenue_from = null,
      this.revenue_upto = null,
      this.average_ticket_size_from = null,
      this.average_ticket_size_upto = null,
      this.user_active = null
      this.is_star_project = true
      this.selectedAdGroups = []
      this.selectedCampaigns = []
      this.physical_pincode = null
      this.ad_strategies = []
      this.ads_names = []
      this.devices= []
      this.keyword_types= []
      this.utm_campaigns= []
      if (this.$route.name === 'Call-Activity' || this.$route.name === 'Backlog' || this.$route.name === 'UserRoi' || this.$route.name === 'ProjectRoi' || this.$route.name === 'SourceRoi' || this.$route.name === 'MarketingActivation') {
        this.$router.replace({ path: this.$route.path, query: {} });
      }
    },
    toggleSource(sourceId){
      let mi = this.sSources.indexOf(sourceId)
      if(mi < 0){
        this.sSources.push(sourceId);
      }else{
        this.sSources.splice(mi, 1);
      }
    },
    applyFilter(){
      this.defaultFilter.searchFn();
      this.hideModal();
    },
    hideModal() {
      this.$bvModal.hide('filterModal');
    },
    selectProject(option) {
      this.$store.dispatch('addProject', option);
    },
    selectExecutive(event) {
      this.$store.dispatch('setExecutive', event.target.value);
    },
    selectRunoUser(event) {
      this.$store.dispatch('setRunoUser', event.target.value);
    },
    selectActiveUser(event) {
      this.$store.dispatch('setActiveUser', event.target.value);
    },
    selectSubStatus() {
      this.$store.dispatch('setSubStatus', this.selectedSubStatus.map(m => m.id));
    },
    selectStatus() {
      this.$store.dispatch('setStatus', this.selectedStatus.map(m => m.id));
    },
    selectThirdParties() {
      this.$store.dispatch('setThirdParties', this.selectedThirdParties.map(m => m.id));
    },
    selectExeUsers() {
      this.$store.dispatch('setExeUsers', this.selectedExeUsers.map(m => m.id));
    },
    selectCities() {
      this.$store.dispatch('setCities', this.selectedCities.map(m => m.id));
    },
    selectSubProjects() {
      this.$store.dispatch('setSubProjects', this.selectedSubProjects.map(m => m.id));
    },
    selectAdGroups() {
      this.$store.dispatch('setAdGroups', this.selectedAdGroups.map(m => m.id));
    },
    selectCampaigns() {
      this.$store.dispatch('setCampaigns', this.selectedCampaigns.map(m => m.id));
    },
    selectMultiManager() {
      this.$store.dispatch('setMultiManager', this.selectedMultiManager.map(m => m.pincode));
    },
    onTodaysCallCheck() {
      this.$store.dispatch('setisTodaysCall', this.todays_call);
    },
    onStarProjectCheck() {
      this.$store.dispatch('setIsStarProject', this.is_star_project);
    },
    onEnquiryInput() {
      this.$store.dispatch('setEnquiry', this.enquiry);
    },
    selectPincode() {
      this.$store.dispatch('setPhysicalPincode', this.physical_pincode.map(m => m.pincode));
    },
    selectAdStrategies() {
      this.$store.dispatch('setAdStrategies', this.ad_strategies);
    },
    selectAdsNames(){
      this.$store.dispatch('setAdsNames', this.ads_names);
    },
    selectDevices() {
      this.$store.dispatch('setDevices', this.devices);
    },
    selectKeywordTypes() {
      this.$store.dispatch('setKeywordTypes', this.keyword_types);
    },
    selectUtmCampaigns(){
      this.$store.dispatch('setUtmCampaigns', this.utm_campaigns);
    },
    removeProject(tag){
      let project = this.selectedProjects.find(project => project.name === tag)
      this.$store.dispatch('removeProject', project);
    }
  },
  computed: {
    activeTitle(){
      return this.$store.getters.activeTitle;
    },
    sManager(){
      return this.$store.getters.selectedManager;
    },
    is_star_project: {
      get() {
        return this.$store.state.is_star_project;
      },
      set(value) {
        this.$store.dispatch('setIsStarProject', value);
      }
    },
    sExecutive(){
      return this.$store.getters.executive;
    },
    sSources(){
      return this.$store.getters.selectedSources;
    },
    sProjects(){
      return this.$store.getters.selectedProjects;
    },
    sStatus(){
      return this.$store.getters.status;
    },
    sSubStatus(){
      return this.$store.getters.substatus;
    },
    sMultiManger(){
      return this.$store.getters.multiManger;
    },
    sExeUsers(){
      return this.$store.getters.exeusers;
    },
    sCities(){
      return this.$store.getters.cities;
    },
    sSubProjects(){
      return this.$store.getters.subProjects;
    },
    sEnquiry(){
      return this.$store.getters.enquiry;
    },
    sPhysicalPincode(){
      return this.$store.getters.physicalPincode;
    },
    sAdGroups(){
      return this.$store.getters.adGroups;
    },
    sCampaigns(){
      return this.$store.getters.campaigns;
    },
    sTodaysCall(){
      return this.$store.getters.todays_call;
    },
    showBack(){
      return !['Source-Wise', 'User-Wise', 'Enquiry-Wise', 'More'].includes(this.$route.name);
    },
    showFilter(){
      return ['SubSource-Wise','Source-Wise', 'User-Wise', 'Enquiry-Wise'].includes(this.$route.name);
    },
    defaultFilter(){
      let routeName = this.$route.name
      if(routeName === "Call-Activity"){
        return this.$store.getters.sDefaults;
      }else if(routeName === "UserRoi"){
        return this.$store.getters.sDefaults;
      }else if(routeName === "MarketingActivation"){
        return this.$store.getters.sDefaults;
      }else if(routeName === "ProjectRoi"){
        return this.$store.getters.sDefaults;
      }else if(routeName === "SourceRoi"){
        return this.$store.getters.sDefaults;
      }else if(routeName === "Backlog"){
        return this.$store.getters.sDefaults;
      } else if(routeName === "Qualification"){
        return this.$store.getters.sDefaults;
      } else if(routeName === "SubSource-Wise"){
        return this.$store.getters.sDefaults;
      }else if(routeName === "Source-Wise"){
        return this.$store.getters.sDefaults;
      } else if(routeName === "User-Wise"){
        return this.$store.getters.uDefaults;
      }else if(routeName === "Enquiry-Wise"){
        return this.$store.getters.eDefaults;
      }else if(routeName === "SubSource-Wise"){
        return this.$store.getters.eDefaults;
      }else if(routeName === "LeadAgeingReports"){
        return this.$store.getters.sDefaults;
      }else if(routeName === "MarketingCampaignReport"){
        return this.$store.getters.sDefaults;
      }else{
        return {};
      }
    },
    isFilterActive(){
      return (this.sManager || this.sSources.length > 0 || this.sProjects.length > 0 || this.sSubStatus.length > 0 ||  this.sExecutive || this.sEnquiry || this.executive_type || this.runo_user || this.sTodaysCall || this.sExeUsers.length > 0 || this.sMultiManger.length > 0 || this.sStatus.length > 0 || this.sCities.length > 0 || this.sSubProjects.length > 0 || this.sPhysicalPincode || this.sAdGroups.length > 0 || this.sCampaigns.length > 0 || this.sDevices.length > 0 || this.sKeywordTypes.length > 0
      || this.sUtmCampaigns.length > 0 || this.sAdStrategies.length > 0 || this.sAdsNames.length > 0)
    },
    criteria() {
      // Compute the search criteria
      return this.search.trim().toLowerCase()
    },
    availableOptions() {
      const criteria = this.criteria
      // Filter out already selected options
      const options = this.projectOptions.filter(opt => this.selectedProjectIds.indexOf(opt.id) === -1)
      if (criteria) {
        // Show only options that match criteria
        return options.filter(opt => opt.name.toLowerCase().indexOf(criteria) > -1);
      }
      // Show all options available
      return options
    },
    selectedProjects(){
      return this.$store.getters.selectedProjects;
    },
    selectedProjectNames(){
      return this.selectedProjects.map(project=>project.name);
    },
    selectedProjectIds(){
      return this.selectedProjects.map(project=>project.id);
    },
    mtrReportFilters(){
      return this.$store.getters.mtrReportFilters;
    },
    sAdStrategies(){
      return this.$store.getters.adStrategies;
    },
    sAdsNames(){
      return this.$store.getters.adsNames;
    },
    sDevices(){
      return this.$store.getters.devices;
    },
    sKeywordTypes(){
      return this.$store.getters.keywordTypes;
    },
    sUtmCampaigns(){
      return this.$store.getters.utmCampaigns;
    }
  }
}
</script>
<style >
.filter-icon{
  position: absolute;
  right: 20px;
}
.filter-icon svg{
    width: 20px;
    height: 20px;
    fill: #C9C9C9;
}
#filterModal .modal-dialog {
    margin: 0;
    max-width: 100%;
}
#filterModal .modal-body {
  padding:2rem 1.5rem 1.5rem;
  min-height: 100vh;
  padding-bottom: 150px;
  background: #F8F8F8;
  
}
#filterModal .modal-content{
    border: none;
    border-radius: 0;
    background-color: #F8F8F8;
}
#filterModal h3{
  font-size: 14px;
  color: rgba(0, 0, 0, .8);
  font-weight: 400;
  margin-bottom: 20px;
}
#filterModal .btn-login{
  margin:0;
  border-radius: 4px;
  height: 45px;
  font-size: 16px;
  font-weight: 400;
}
#filterModal .form-group {
    margin-bottom: 1.5rem;
}
#filterModal .form-group svg {
    position: absolute;
    top: 22px;
    width: 15px;
    opacity: .3;
    right: 15px;
    left: initial;
}
#filterModal .form-group input{
  box-shadow: 2px 3px 16px #4671950D;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  padding: 24px;
}
#filterModal .form-group .custom-select{
  box-shadow: 2px 3px 16px #4671950D;
    border: none;
    border-radius: 4px;
    font-size: 12px;
    padding:0;
    background: #fff;
    height: 45px;
     color: rgba(0, 0, 0, .6);
}
#filterModal .btn-outline-secondary{
  height: 45px;
  text-align: left;
  color: rgba(0, 0, 0, .6);
  border: none;
}
#filterModal .dropdown-divider{
  margin-top: 0;
}

.show > .btn-outline-secondary.dropdown-toggle{
    background: #F8E2D0!important;
    color: #F58634!important;
    border-color:#F58634!important;
}
#filterModal .dropdown-menu{
  background-color: #f8f8f8;
  padding: 0;
  max-height: calc(100vh - 180px);
  overflow: scroll;
}
#filterModal  .dropdown-toggle::after{
      float: right;
    margin-top: 10px;
    opacity: .5;
    margin-right: 10px;
}

.selectedFilter{
  width: 10px;
  height: 10px;
  display: block;
  background: rgb(245, 134, 52);
  border-radius: 50%;
  position: absolute;
  right: -5px;
  top: 2px;
}
.form-group .btn-outline {
    border: 1px solid #dfdfdf;
    border-radius: 25px;
    padding: 8px 15px;
    font-size: 12px;
    margin-right: 10px;
    color: #212121;
    font-weight: 500;
     margin: 10px;
}
.btn-outline:hover{
  background-color: transparent;
   color: #212121!important;
    border: 1px solid #dfdfdf;
}
.btn-outline.active{
  background-color: #F8E2D0;
    opacity: 1;
    color: #F58634!important;
    border-color:#F58634;
}

#filterModal .badge-info{
      color: #F58634!important;
    border-color: #F58634;
    border-radius: 25px;
    padding: 5px 15px;
    margin: 5px 0 5px 6px;
    font-weight: 600!important;
    font-size: 12px!important;
     background: #F8E2D0!important;
}
#filterModal .b-dropdown-form{
  padding: 0;
}
h3 .close{
  font-weight: 300;
  margin-top: -9px;
  font-size: 30px;
}
.fixed-btn{
  position: fixed;
  bottom: 0;
  left: 0;
  padding:0 25px 15px 25px;
  background: #fff;
  z-index: 99;
  width: 100%;
  box-shadow: 0px 1px 10px #00000008;
}
.b-dropdown-text{
  font-size: 14px;
  padding-bottom: 10px!important;
  opacity: .6!important;
    font-weight: 600!important;
}
.clearfilter {
    display: table;
    margin: 15px auto;
    font-size: 14px;
    opacity: .6;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>